import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthenticationGuard = ({
  children,
  requiredRoles = [],
  currentUserRole = null,
  isAuthenticated = false
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      // Determine which login page to redirect to based on required roles
      const isAdminRoute = requiredRoles?.includes('owner') || requiredRoles?.includes('contributor');
      const isUserRoute = requiredRoles?.includes('user');

      let redirectPath = '/admin-login';

      if (isUserRoute && !isAdminRoute) {
        // User-only route, redirect to user registration
        redirectPath = '/user-registration';
      }

      navigate(redirectPath, {
        state: { from: location?.pathname },
        replace: true
      });
      return;
    }

    // Only check role if we have a currentUserRole (profile is loaded)
    // The ProtectedRoute component handles the loading state
    if (requiredRoles?.length > 0 && currentUserRole && !requiredRoles?.includes(currentUserRole)) {
      // Redirect to appropriate dashboard based on actual role
      let redirectPath = currentUserRole === 'owner' ? '/owner-dashboard'
        : currentUserRole === 'contributor' ? '/contributor-dashboard'
          : currentUserRole === 'user' ? '/user-dashboard' : '/';

      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, requiredRoles, currentUserRole, navigate, location]);

  if (!isAuthenticated) {
    return null;
  }

  // Only block if we have a role and it's not in the required list
  if (requiredRoles?.length > 0 && currentUserRole && !requiredRoles?.includes(currentUserRole)) {
    return null;
  }

  return <>{children}</>;
};

export default AuthenticationGuard;